import { createBrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";

import { routes } from "./routes";

const wrappedCreateRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = wrappedCreateRouter(
  routes,
  {
    future: {
    },
  }
);
